import React, { useEffect, useState } from "react";
import AddCreditPayGoFormView, {
  PayGoCreditDecryptedView,
} from "./AddCreditPayGoFormView";
import { useMutation } from "react-query";
import { getDecryptedPaygoCreditOfStation } from "../../../../stations/services/stationsAPI";
import StationPicker from "../../../../stations/components/StationPicker/StationPicker";
import { Station } from "../../../../stations/types/stations.types";
import { PayGoCreditDecrypted } from "../../../../paygo/types/paygo.types";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import { numberFormaterString } from "../../../../../utils/numberFormater";
import { useSingleWallet } from "../../../hooks/useWallet";
import { extractAxoisErrorsMessage } from "../../../../errorHandler/utils/errors.utils";



export interface DataFormAddPayGoCredit {
  paygoCode?: string;
  station?: Station;
}

export interface ErrorStatus {
  allgood: boolean;
  message?: string;
  isErrorPaygoCode?: boolean;
  isErrorStation?: boolean;
}

const INITIAL_ERROR_STATUS: ErrorStatus = {
  allgood: true,
  message: "",
  isErrorPaygoCode: false,
  isErrorStation: false,
};
export default function AddCreditPaygoForm({
  onSuccess,
  walletId,
}: {
  onSuccess?: () => void;
  walletId?: string;
}) {
  //const [isDone, setIsDone] = useState(false);
  const [dataForm, setDataForm] = useState<DataFormAddPayGoCredit>({});
  const [payGoCreditDecrypoted, setPayGoCreditDecrypted] = useState<
    PayGoCreditDecrypted | null | undefined
  >(undefined);

  const [errorStatus, setErrorStatus] = useState<ErrorStatus>({
    ...INITIAL_ERROR_STATUS,
  });

  const isFormValid = () => {
    let message = [];
    let errorStatusNew = { ...INITIAL_ERROR_STATUS };
    if (!dataForm.paygoCode || dataForm.paygoCode?.length < 20) {
      errorStatusNew.allgood = false;
      errorStatusNew.isErrorPaygoCode = true;
      message.push("Veuillez remplir un code PayGo valide");
    }

    if (!dataForm.station?.station_id) {
      errorStatusNew.allgood = false;
      errorStatusNew.isErrorStation = !dataForm.station;
      message.push("Veuillez sélectionner une station valide");
    }

    if (message.length > 0) {
      errorStatusNew.message = message.join(" ");
    } else {
      errorStatusNew.allgood = true;
      errorStatusNew.message = "";
    }

    return errorStatusNew;
  };

  const mutateDecryptPaygoCode = useMutation({
    mutationFn: async () => {
      return await getDecryptedPaygoCreditOfStation(
        dataForm.station?.station_id || "none",
        dataForm.paygoCode || "none"
      );
    },
    onSuccess: (data) => {
      setPayGoCreditDecrypted(data);
    },
    onError: (error) => {
      console.error("Error decrypting PayGo code:", error);
    },
  });

  const {addPayGoCreditQuery} = useSingleWallet(walletId);


  const handleClickSubmit = () => {
    if (payGoCreditDecrypoted?.paygocred_amount_credit) {
      addPayGoCreditQuery.mutate({
        paygoToken: dataForm.paygoCode || "",
        stationSlug: dataForm.station?.station_slug || "",
      }, {
        onSuccess: () => {
          onSuccess && onSuccess();
        },
        onError: (error: any) => {
          setErrorStatus({
            ...errorStatus,
            allgood: false,
            message: extractAxoisErrorsMessage(error) || "Erreur lors de l'ajout du crédit PayGo",
            isErrorPaygoCode: true,
          });
        },
      });
    } else {
      mutateDecryptPaygoCode.mutate();
    }
  }
  useEffect(() => {
    const newErrorStatus = isFormValid();
    mutateDecryptPaygoCode.reset();
    if (newErrorStatus.allgood) {
      setErrorStatus(INITIAL_ERROR_STATUS);
      mutateDecryptPaygoCode.mutate();
    } else {
      setErrorStatus(newErrorStatus);
    }
    
  }, [dataForm.station, dataForm.paygoCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (mutateDecryptPaygoCode.isError) {
      setErrorStatus({
        ...errorStatus,
        allgood: false,
        message: "PayGo est invalide",
        isErrorPaygoCode: true,
      });
    } else {
      setErrorStatus({
        ...errorStatus,
        allgood: true,
        message: "",
        isErrorPaygoCode: false,
      });
    }
  }, [mutateDecryptPaygoCode.isError]); // eslint-disable-line react-hooks/exhaustive-deps
  const setDataFormValue = (key: keyof DataFormAddPayGoCredit, value: any) => {
    setDataForm({
      ...dataForm,
      [key]: value,
    });
  };

  return (
    <>
      <AddCreditPayGoFormView
        setDataForm={setDataFormValue}
        dataForm={dataForm}
        handleSubmit={handleClickSubmit}
        isLoading={mutateDecryptPaygoCode.isLoading || addPayGoCreditQuery.isLoading}
        selectStationInputRender={() => (
          <StationPicker
            currentStation={dataForm?.station}
            setCurrentStation={(station) => {
              setDataFormValue("station", station);
            }}
            isError={errorStatus.isErrorStation}
          />
        )}
        payGoCreditDecryptedValue={
          payGoCreditDecrypoted?.paygocred_amount_credit
        }
        errorStatus={errorStatus}
        disableSubmit={!errorStatus.allgood || mutateDecryptPaygoCode.isLoading}
        submitLabel={!payGoCreditDecrypoted?.paygocred_amount_credit ? "Ajouter du Crédit" : "Ajouter "+ numberFormaterString(payGoCreditDecrypoted?.paygocred_amount_credit) + " " + payGoCreditDecrypoted?.paygocred_currency +" de crédit"}
        paygoDecryptedRender={() => (
          <div style={{ height: "80px" }}>
            {mutateDecryptPaygoCode.isLoading && (
              <LoaderSreen heigth={"20px"} />
            )}

            {mutateDecryptPaygoCode.isSuccess && (
              <PayGoCreditDecryptedView
                amountCredit={payGoCreditDecrypoted?.paygocred_amount_credit}
                currency={payGoCreditDecrypoted?.paygocred_currency}
              />
            )}
          </div>
        )}
      />
    </>
  );
}
